var ua = navigator.userAgent.toLowerCase();
var safari = document.getElementById("safari");
var chrome = document.getElementById("chrome");

window.onload = function () {
  if (ua.indexOf("safari") != -1) {
    if (ua.indexOf("chrome") > -1) {
      safari.remove();
     // console.log("chrome");
    } else {
      chrome.remove();
     // console.log("safari");
    }
  }
  var browser = navigator.userAgent.toLowerCase();
  if (browser.indexOf("firefox") > -1) {
    safari.remove();
    //console.log("Firefox");
  }
};
